export const BUTTON_VALUE = 'Confirmar alteração';
export const RECEIVER_IS_NOT_AUTHENTICATED = 'receiver_is_not_authenticated';
export const ERROR_DESCRIPTION =
  'Algo deu errado e não conseguimos confirmar a alteração.';
